import React, { memo } from 'react'
import { FormValidation } from '@rjsf/utils'

import { useSettingsPopupState } from '../hooks'
import { useNlpModels } from '../../../store/flow'
import { CustomFormPopup } from '../CustomFormPopup'
import { cleanEmptyProperties } from '../../../lib/rjsf'
import { ModalDescriptorForType } from '../../../store/modals'
import { useClassifyUtterance } from '../../../features/nlp-analyzer'
import {
  isModelChoosen,
  injectModelsToSchemaWithoutExpectedModelMatchOption
} from '../sharedSchemaFragments/nlpModelsTest/utils'
import {
  schema,
  uiSchema,
  FormData,
  defaultFormData
} from '../sharedSchemaFragments/nlpModelsTest/constants'

type Props = { modalDescriptor: ModalDescriptorForType<'utterance_classifier'> }

export const UtteranceClassifierPopup: React.FC<Props> = memo(({ modalDescriptor }) => {
  const allModels = useNlpModels()
  const { formData = '', onFormDataChange } = useSettingsPopupState(() => defaultFormData) as any
  const { triggerRequest, isRequestInProgress } = useClassifyUtterance()(
    formData?.testAgainstModels?.mode === 'CHOOSE'
      ? allModels.filter(isModelChoosen(formData))
      : allModels
  )

  return (
    <CustomFormPopup<FormData>
      title={`Utterance classifier - test unmatched utterance "${modalDescriptor.utterance}"`}
      labels={{ buttons: { submit: 'Run test' } }}
      modalStyle={{ content: { height: '60%' } }}
      uiSchema={uiSchema}
      isLoading={isRequestInProgress}
      formData={cleanEmptyProperties(formData)}
      schema={injectModelsToSchemaWithoutExpectedModelMatchOption(schema, allModels)}
      onChange={onFormDataChange}
      onSubmit={() => triggerRequest(modalDescriptor.utterance)}
      validateSchema={(formData, errors: FormValidation<any>) => {
        // No idea why I have to do this - `minItems: 1` should take care of it, but it doesn't work
        if (
          formData?.testAgainstModels?.mode === 'CHOOSE' &&
          !formData?.testAgainstModels?.chosenModels?.length
        ) {
          errors.testAgainstModels?.chosenModels?.addError('Please choose at least one model.')
        }

        return errors
      }}
    />
  )
})
